/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export const getFilterItems = async (moduleName, key, queryString = {}) => {
  try {
    const url = moduleName
      ? generateApiUrl(
          ["globalServices", "filter_module"],
          [moduleName, key],
          queryString
        )
      : generateApiUrl(["globalServices", "filter_id"], [key], queryString);

    const response = await httpService.get(url);
    const items = pathOr([], ["data", "data"], response);
    return { items };
  } catch (error) {
    throw error;
  }
};
export const getFilterCache = async (resource) => {
  try {
    const url = generateApiUrl(["globalServices", "filter_cache"], [], {
      resource,
    });
    const response = await httpService.get(url);
    const params = pathOr(null, ["data", "data", "query_params"], response);
    return { params };
  } catch (error) {
    throw error;
  }
};
export const deleteFilterCache = async (resource) => {
  try {
    const url = generateApiUrl(["globalServices", "filter_cache"], [], {
      resource,
    });
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
